module.exports = __webpack_public_path__ + "img/warning-icon.1b7f2398.svg";